import { render, staticRenderFns } from "./DrugEditMix.vue?vue&type=template&id=1524d49c&scoped=true"
import script from "./DrugEditMix.vue?vue&type=script&lang=js"
export * from "./DrugEditMix.vue?vue&type=script&lang=js"
import style0 from "../../../sass/pharmacy/editPharmacy.scss?vue&type=style&index=0&id=1524d49c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1524d49c",
  null
  
)

export default component.exports